/*
  Upsell in de winkelwagenlade.

  Dit stond eerder als <script> in zs-cart-upsell.liquid, maar dat blok wordt
  alleen gerenderd als de winkelwagen niet leeg is. Bij een lege winkelwagen
  stond het dus niet in de pagina, en na het toevoegen van een product zet
  Dawn de nieuwe lade met innerHTML in beeld -- waarbij scripts niet
  uitgevoerd worden. De knoppen deden daardoor niets tot je de pagina
  vernieuwde. Als los bestand wordt het altijd geladen.
*/
(function () {
  // Eén keer binden op document: het blok wordt bij elke wijziging vervangen,
  // en een listener op het blok zelf zou daarmee verdwijnen.
  if (window.zsUpsellGebonden) return;
  window.zsUpsellGebonden = true;

  var SECTIES = 'cart-drawer,cart-icon-bubble';

  // Bewust XMLHttpRequest en geen fetch: op de winkel vervangt Shopify's
  // pixel-manager window.fetch, en die wrapper faalt soms. Dan mislukte het
  // toevoegen zonder dat er iets zichtbaar gebeurde.
  function verstuur(url, data) {
    return new Promise(function (klaar, mis) {
      var x = new XMLHttpRequest();
      x.open('POST', url, true);
      x.setRequestHeader('Content-Type', 'application/json');
      x.onload = function () {
        if (x.status < 200 || x.status >= 300) {
          mis(new Error('winkelwagen gaf ' + x.status));
          return;
        }
        try {
          klaar(JSON.parse(x.responseText));
        } catch (e) {
          mis(e);
        }
      };
      x.onerror = function () { mis(new Error('netwerkfout')) };
      x.send(JSON.stringify(data));
    });
  }

  function pasSectiesToe(data) {
    if (!data || !data.sections) return;

    var drawerHtml = data.sections['cart-drawer'];
    if (drawerHtml) {
      var nieuw = new DOMParser().parseFromString(drawerHtml, 'text/html');
      ['cart-drawer-items', '.cart-drawer__footer', '#ZsCartUpsell', '.cart__ctas'].forEach(function (kies) {
        var doel = document.querySelector(kies);
        var bron = nieuw.querySelector(kies);
        if (doel && bron) doel.replaceWith(bron);
      });
    }

    var bubbelHtml = data.sections['cart-icon-bubble'];
    if (bubbelHtml) {
      var bubbel = document.getElementById('cart-icon-bubble');
      var nb = new DOMParser().parseFromString(bubbelHtml, 'text/html').querySelector('.shopify-section');
      if (bubbel && nb) bubbel.innerHTML = nb.innerHTML;
    }
  }

  document.addEventListener('click', function (e) {
    var knop = e.target.closest && e.target.closest('.zs-upsell__knop');
    if (!knop || knop.disabled) return;

    var rij = knop.closest('.zs-upsell__rij');
    if (!rij || rij.dataset.bezig === 'ja') return;

    var variant = Number(rij.dataset.variant);
    var huidig = Number(rij.dataset.aantal || 0);
    var doel = knop.classList.contains('zs-upsell__knop--plus') ? huidig + 1 : huidig - 1;
    if (doel < 0) return;

    // Toevoegen haalt de regel hier weg: hij verschijnt als gewone regel
    // bovenin. De teller alvast ophogen zou dan een tel lang iets tonen dat
    // meteen weer verdwijnt, dus dat doen we alleen bij een wijziging.
    rij.dataset.bezig = 'ja';
    var teller = rij.querySelector('.zs-upsell__aantal');
    if (huidig === 0) {
      rij.style.opacity = '0.6';
      knop.disabled = true;
    } else {
      rij.dataset.aantal = String(doel);
      if (teller) teller.textContent = doel;
      rij.classList.toggle('zs-upsell__rij--leeg', doel === 0);
      rij.querySelector('.zs-upsell__knop--min').disabled = doel === 0;
    }

    var pad = window.location.pathname;
    var verzoek = huidig === 0
      ? verstuur('/cart/add.js', { items: [{ id: variant, quantity: 1 }], sections: SECTIES, sections_url: pad })
      : verstuur('/cart/change.js', { id: String(variant), quantity: doel, sections: SECTIES, sections_url: pad });

    verzoek
      .then(pasSectiesToe)
      .catch(function (fout) {
        console.error('Upsell kon de winkelwagen niet bijwerken:', fout);
        // Terugdraaien zodat het scherm niet iets anders beweert dan de winkelwagen.
        rij.style.opacity = '';
        knop.disabled = false;
        rij.dataset.aantal = String(huidig);
        if (teller) teller.textContent = huidig;
        rij.classList.toggle('zs-upsell__rij--leeg', huidig === 0);
        rij.querySelector('.zs-upsell__knop--min').disabled = huidig === 0;
      })
      .finally(function () {
        rij.dataset.bezig = '';
      });
  });
})();
